import { createSlice } from "@reduxjs/toolkit";

interface ModalState {
  isLoginOpen: boolean;
  isSignUpOpen: boolean;
  isOtpOpen: boolean;
  isSuccessful: boolean;
  isForgetPassword: boolean;
  isResetPassword: boolean;
  isResetPasswordOtp: boolean;
  addModelData: boolean;
  updateModelData: boolean;
  footerModel: boolean;
  selectAddressModel: boolean;
  addAnotherAddress: boolean;
  addDetailModel: boolean;
  verifyOtp: boolean;
  login: boolean;
  addressFromMap: boolean;
  uploadFileModel: boolean;
  getQuoteModel: boolean;
  languadesModel: boolean;
  packageModel: boolean;
  priceModel: boolean;
  yesnoModel: boolean;
  insideOutsideModel: boolean;
  skilledUnskilledModel: boolean;
  newModel: boolean;
  confirmData: boolean;
  scanModel: boolean;
  cameraModel: boolean;
  recentlyAdded: boolean;
  editForPackageModel: boolean;
  tickModel: boolean;
  smodel: boolean;
  newPackageModel: boolean;
  readFullPolicyModel: boolean;
  packageAndServiceModel: boolean;
  serviceListDisplayModel: boolean;
  documentsDisplayModel: boolean;
  documentsListDisplayModel: boolean;
  serviceListData: any | null;
  documentData: {
    files: {
      applicantName: string;
      storedName: string;
      originalName: string;
      label: string;
      isGroup: number;
      RecordId: number;
    }[];
  } | null;
  activityCategoryModel: boolean;
  activityListModel: boolean;
  activityDetailModel: boolean;
}

const initialState: ModalState = {
  isLoginOpen: false,
  isSignUpOpen: false,
  isOtpOpen: false,
  isSuccessful: false,
  isForgetPassword: false,
  isResetPassword: false,
  isResetPasswordOtp: false,
  addModelData: false,
  updateModelData: false,
  footerModel: false,
  selectAddressModel: false,
  addAnotherAddress: false,
  addDetailModel: false,
  verifyOtp: false,
  login: false,
  addressFromMap: false,
  uploadFileModel: false,
  getQuoteModel: false,
  languadesModel: false,
  packageModel: false,
  priceModel: false,
  yesnoModel: false,
  insideOutsideModel: false,
  skilledUnskilledModel: false,
  newModel: false,
  confirmData: false,
  scanModel: false,
  cameraModel: false,
  recentlyAdded: false,
  editForPackageModel: false,
  tickModel: false,
  smodel: false,
  newPackageModel: false,
  readFullPolicyModel: false,
  packageAndServiceModel: false,
  serviceListDisplayModel: false,
  documentsDisplayModel: false,
  documentsListDisplayModel: false,
  serviceListData: null,
  documentData: null,
  activityCategoryModel:false,
  activityListModel:false,
  activityDetailModel:false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openLogin(state) {
      state.isLoginOpen = true;
    },
    closeLogin(state) {
      state.isLoginOpen = false;
    },
    openSignUp(state) {
      state.isSignUpOpen = true;
    },
    closeSignUp(state) {
      state.isSignUpOpen = false;
    },
    openOtp(state) {
      state.isOtpOpen = true;
    },
    closeOtp(state) {
      state.isOtpOpen = false;
    },
    openSuccessful(state) {
      state.isSuccessful = true;
    },
    closeSuccessful(state) {
      state.isSuccessful = false;
    },
    openForgetPassword(state) {
      state.isForgetPassword = true;
    },
    closeForgetPassword(state) {
      state.isForgetPassword = false;
    },
    openResetPassword(state) {
      state.isResetPassword = true;
    },
    closeResetPassword(state) {
      state.isResetPassword = false;
    },
    openResetPasswordOtp(state) {
      state.isResetPasswordOtp = true;
    },
    closeResetPasswordOtp(state) {
      state.isResetPasswordOtp = false;
    },
    openAddModelData(state) {
      state.addModelData = true;
    },
    closeAddModelData(state) {
      state.addModelData = false;
    },
    openUpdateModelData(state) {
      state.updateModelData = true;
    },
    closeUpdateModelData(state) {
      state.updateModelData = false;
    },
    openFooterModel(state) {
      state.footerModel = true;
    },
    closeFooterModel(state) {
      state.footerModel = false;
    },
    openSelectAddressModel(state) {
      state.selectAddressModel = true;
    },
    closeSelectAddressModel(state) {
      state.selectAddressModel = false;
    },
    openAddAnotherAddress(state) {
      state.addAnotherAddress = true;
    },
    closeAddAnotherAddress(state) {
      state.addAnotherAddress = false;
    },
    openAddDetailModel(state) {
      state.addDetailModel = true;
    },
    closeAddDetailModel(state) {
      state.addDetailModel = false;
    },
    openVerifyOtp(state) {
      state.verifyOtp = true;
    },
    closeVerifyOtp(state) {
      state.verifyOtp = false;
    },
    openNewLogin(state) {
      state.login = true;
    },
    closeNewLogin(state) {
      state.login = false;
    },
    openAddressFromMap(state) {
      state.addressFromMap = true;
    },
    closeAddressFromMap(state) {
      state.addressFromMap = false;
    },
    openUploadFileModel(state) {
      state.uploadFileModel = true;
    },
    closeUploadFileModel(state) {
      state.uploadFileModel = false;
    },
    openGetQuoteModel(state) {
      state.getQuoteModel = true;
    },
    closeGetQuoteModel(state) {
      state.getQuoteModel = false;
    },
    openLanguadesModel(state) {
      state.languadesModel = true;
    },
    closeLanguadesModel(state) {
      state.languadesModel = false;
    },
    openPackageModel(state) {
      state.packageModel = true;
    },
    closePackageModel(state) {
      state.packageModel = false;
    },
    openPriceModel(state) {
      state.priceModel = true;
    },
    closePriceModel(state) {
      state.priceModel = false;
    },
    openYesNoModel(state) {
      state.yesnoModel = true;
    },
    closeYesNoModel(state) {
      state.yesnoModel = false;
    },
    openInsideOutsideModel(state) {
      state.insideOutsideModel = true;
    },
    closeInsideOutsideModel(state) {
      state.insideOutsideModel = false;
    },
    openSkilledUnskilledMode(state) {
      state.skilledUnskilledModel = true;
    },
    closeSkilledUnskilledModel(state) {
      state.skilledUnskilledModel = false;
    },
    openNewModel(state) {
      state.newModel = true;
    },
    closeNewModel(state) {
      state.newModel = false;
    },
    openConfirmDataModel(state) {
      state.confirmData = true;
    },
    closeConfirmDataModel(state) {
      state.confirmData = false;
    },
    openScanDataModel(state) {
      state.scanModel = true;
    },
    closeScanDataModel(state) {
      state.scanModel = false;
    },
    openCameraModel(state) {
      state.cameraModel = true;
    },
    closeCameraModel(state) {
      state.cameraModel = false;
    },
    setRecentlyAddedTrue(state) {
      state.recentlyAdded = true;
    },
    setRecentlyAddedFalse(state) {
      state.recentlyAdded = false;
    },
    setEditForPackageModel(state) {
      state.editForPackageModel = true;
    },
    setEditForPackageFalse(state) {
      state.editForPackageModel = false;
    },
    setTickModelTrue(state) {
      state.tickModel = true;
    },
    setTickModelFalse(state) {
      state.tickModel = false;
    },
    setSmodelTrue(state) {
      state.smodel = true;
    },
    setSmodelFalse(state) {
      state.smodel = false;
    },
    setNewPackageModelTrue(state) {
      state.newPackageModel = true;
    },
    setNewPackageModelFalse(state) {
      state.newPackageModel = false;
    },
    setReadFullPolicyModelTrue(state) {
      state.readFullPolicyModel = true;
    },
    setReadFullPolicyModelFalse(state) {
      state.readFullPolicyModel = false;
    },
    setPackageAndServiceModelTrue(state) {
      state.packageAndServiceModel = true;
    },
    setPackageAndServiceModelFalse(state) {
      state.packageAndServiceModel = false;
    },

    openServiceListDisplayModel(state, action) {
      state.serviceListDisplayModel = true;
      state.serviceListData = action.payload;
    },
    closeServiceListDisplayModel(state) {
      state.serviceListDisplayModel = false;
      state.serviceListData = null;
    },

    openDocumentsDisplayModel(state, action) {
      const field = action.payload;

      const files: {
        ApplicantName?: string;
        stored_name?: string;
        original_name?: string;
        Label?: string;
        PlaceHolder?: string;
      }[] = field.multiOptions?.length
        ? field.multiOptions.filter((opt: any) => opt.uploaded)
        : field.uploaded
        ? [field]
        : [];

      state.documentsDisplayModel = true;

      state.documentData = {
        files: files.map((file: any) => ({
          applicantName: file.ApplicantName ?? "",
          storedName: file.stored_name ?? "",
          originalName: file.original_name ?? "",
          label: file.PlaceHolder ?? "",
          isGroup: file.isGroup ?? 0,
          RecordId: file.RecordId,
        })),
      };
    },
    closeDocumentsDisplayModel(state) {
      state.documentsDisplayModel = false;
      state.documentData = null;
    },
    openDocumentsListDisplayModel(state, action) {
      const documents = action.payload;
      
      let files: any[] = [];
      
      if (Array.isArray(documents)) {
        files = documents.map((doc: any) => ({
          applicantName: doc.applicantName || doc.ApplicantName || doc.applicant_Name || "",
          storedName: doc.storedName || doc.stored_name || doc.original_name || "",
          originalName: doc.originalName || doc.original_name || doc.storedName || "",
          label: doc.label || doc.Label || doc.PlaceHolder || doc.LabelName || "Document",
          isGroup: doc.isGroup || 0,
          RecordId: doc.RecordId || doc.id || 0,
        }));
      } else if (documents && typeof documents === 'object') {
        const field = documents;
        const fieldFiles: {
          ApplicantName?: string;
          stored_name?: string;
          original_name?: string;
          Label?: string;
          PlaceHolder?: string;
        }[] = field.multiOptions?.length
          ? field.multiOptions.filter((opt: any) => opt.uploaded)
          : field.uploaded
          ? [field]
          : [];

        files = fieldFiles.map((file: any) => ({
          applicantName: file.ApplicantName ?? "",
          storedName: file.stored_name ?? "",
          originalName: file.original_name ?? "",
          label: file.PlaceHolder ?? "",
          isGroup: file.isGroup ?? 0,
          RecordId: file.RecordId,
        }));
      }

      state.documentsListDisplayModel = true;
      state.documentData = {
        files: files,
      };
    },
    closeDocumentsListDisplayModel(state) {
      state.documentsListDisplayModel = false;
      state.documentData = null;
    },
    openActivityCategoryModel(state) {
      state.activityCategoryModel = true;
    },
    closeActivityCategoryModel(state) {
      state.activityCategoryModel = false;
    },
    openActivityListModel(state) {
      state.activityListModel = true;
    },
    closeActivityListModel(state) {
      state.activityListModel = false;
    },
    openActivityDetailModel(state) {
      state.activityDetailModel = true;
    },
    closeActivityDetailModel(state) {
      state.activityDetailModel = false;
    },
  },
});

export const {
  openDocumentsDisplayModel,
  closeDocumentsDisplayModel,
  openDocumentsListDisplayModel,
  closeDocumentsListDisplayModel,
  openServiceListDisplayModel,
  closeServiceListDisplayModel,
  openLogin,
  closeLogin,
  openSignUp,
  closeSignUp,
  openOtp,
  closeOtp,
  openSuccessful,
  closeSuccessful,
  openForgetPassword,
  closeForgetPassword,
  openResetPassword,
  closeResetPassword,
  openResetPasswordOtp,
  closeResetPasswordOtp,
  openAddModelData,
  closeAddModelData,
  openUpdateModelData,
  closeUpdateModelData,
  openFooterModel,
  closeFooterModel,
  openSelectAddressModel,
  closeSelectAddressModel,
  openAddAnotherAddress,
  closeAddAnotherAddress,
  openAddDetailModel,
  closeAddDetailModel,
  openVerifyOtp,
  closeVerifyOtp,
  openNewLogin,
  closeNewLogin,
  openAddressFromMap,
  closeAddressFromMap,
  openUploadFileModel,
  closeUploadFileModel,
  openGetQuoteModel,
  closeGetQuoteModel,
  openLanguadesModel,
  closeLanguadesModel,
  openPackageModel,
  closePackageModel,
  openPriceModel,
  closePriceModel,
  openYesNoModel,
  closeYesNoModel,
  openInsideOutsideModel,
  closeInsideOutsideModel,
  openSkilledUnskilledMode,
  closeSkilledUnskilledModel,
  openNewModel,
  closeNewModel,
  openConfirmDataModel,
  closeConfirmDataModel,
  openScanDataModel,
  closeScanDataModel,
  openCameraModel,
  closeCameraModel,
  setRecentlyAddedTrue,
  setRecentlyAddedFalse,
  setEditForPackageModel,
  setEditForPackageFalse,
  setTickModelTrue,
  setTickModelFalse,
  setSmodelTrue,
  setSmodelFalse,
  setNewPackageModelTrue,
  setNewPackageModelFalse,
  setReadFullPolicyModelTrue,
  setReadFullPolicyModelFalse,
  setPackageAndServiceModelTrue,
  setPackageAndServiceModelFalse,
  openActivityCategoryModel,
  closeActivityCategoryModel,
  openActivityListModel,
  closeActivityListModel,
  openActivityDetailModel,
  closeActivityDetailModel,
} = modalSlice.actions;

export default modalSlice.reducer;
